export const TIME_PERIOD = {
    timePeriod: {
        title: 'Timeperiod',
        type: 'dropDown',
        selectedValue: { title: '1/1/2022 – 12/31/2022', value: '1/1/2022 – 12/31/2022' },
        width: '237px',
        filterOptionsSize: 'large',
        filterType: 1,
        isSorted: false,
        filterDisplayKey: 'value',
        filterValueKey: 'value',
        filterKey: 'timePeriod',
        key: 'timePeriod',
        disabled: true,
        options: [],
        activeFilter: false,
        filterDisable: false,
    },
};
export const LOB = {
    LoB: {
        title: 'LoB',
        type: 'dropDown',
        selectedValue: { title: 'All Lines of Business', value: 'All Lines of Business' },
        width: '230px',
        filterOptionsSize: 'large',
        filterType: 2,
        isSorted: true,
        filterDisplayKey: 'value',
        filterValueKey: 'value',
        filterKey: 'LoB',
        key: 'LoB',
        disabled: true,
        options: [],
        activeFilter: false,
        filterDisable: true,
        dropDowndisabled: true,
    },
};
export const TAX_ID = {
    taxId: {
        selectedValue: { value: 'All', title: 'All' },
        type: 'Search',
        width: '230px',
        filterOptionsSize: 'small',
        options: [{ title: '', value: '' }],
        activeFilter: true,
        disableSC: false,
        resetFilter: true,
        showFilter: true,
        filterDisplayKey: 'title',
        filterOptionType: 2,
        filterValueKey: 'value',
        sliceArray: true,
        filterKey: 'taxId',
        key: 'taxId',
        filterLabel: 'All Tax IDs',
        dropdownNote: 'Tax IDs',
        searchType: 2,
    },
};

export interface FilterOption {
    name: string;
    value: string;
    disable?: boolean;
    default?: boolean;
}
export const TIME_PERIOD_OPTIONS: FilterOption[] = [
    { name: 'Last30Days', value: 'Last 30 Days', disable: false },
    { name: 'Rolling3Months', value: 'Rolling 3 Months', disable: false },
    { name: 'Last3Months', value: 'Last 3 Months', disable: false },
    { name: 'Last6Months', value: 'Last 6 Months', disable: false },
    { name: 'Last12Months', value: 'Last 12 Months', disable: false },
    { name: 'YTD', value: 'Year to Date', disable: false },
    { name: (new Date().getFullYear() - 1).toString(), value: (new Date().getFullYear() - 1).toString(), disable: false },
    { name: (new Date().getFullYear() - 2).toString(), value: (new Date().getFullYear() - 2).toString(), disable: false },
    // custom date options
    { name: 'CustomMonth', value: 'Custom Month', disable: false },
    { name: 'CustomDay', value: 'Custom Day (same month only)', disable: false }
];
export interface ILobNames {
    all: string;
    eAndICommerCial: string;
    mAndRMedicare: string;
    cAndSMedicaid: string;
    unCategorized: string;
    exchange: string;
    dual: string;
    unknown: string;
}
export const lobName: ILobNames = {
    all: 'All',
    eAndICommerCial: 'Commercial',
    mAndRMedicare: 'Medicare',
    cAndSMedicaid: 'Medicaid',
    unCategorized: 'Uncategorized',
    exchange: 'Individual Exchange',
    dual: 'Dual',
    unknown: 'Unknown'
};
export const LOB_OPTIONS: FilterOption[] = [
    { name: 'All', value: lobName.all, disable: false },
    { name: 'EI', value: lobName.eAndICommerCial, disable: false },
    { name: 'CS', value: lobName.cAndSMedicaid, disable: false },
    { name: 'MR', value: lobName.mAndRMedicare, disable: false },
    { name: 'EXC', value: lobName.exchange, disable: false },
    { name: 'DL', value: lobName.dual, disable: false },
    // { name: 'UN', value: lobName.unknown, disable: false }, uncomment when unknown is added
    { name: 'UN', value: lobName.unCategorized, disable: true }
];

export const roundingPercentage = (number: number): string => {
    if (0 < number && number < 1) return '<1';
    else if (1 < number && number < 10) return `0${number}`;
    else if (99 < number && number < 100) return '>99';
    else return number?.toFixed();
}
export const DateFormatAPI = (timeStamp: string): string => {
    if (!timeStamp) return '';
    if (timeStamp.includes('T'))
        return timeStamp.split('T')[0]; // "2019-07-01T00:00:00.000+0000"
    else
        return timeStamp.split(' ')[0]; // "2019-02-01 06:00:00"
}
export const getFormattedDate = (date) => {
    if (!date) return '';
    date = date.split('-');
    const year = date[0];
    const month = date[1];
    const day = date[2];
    return month + '/' + day + '/' + year;
}
export const TRANSACTION_TYPE_OPTIONS: any[] = [
    { name: 'Claims', value: 'Claims' },
    { name: 'Eligibility', value: 'Eligibility' },
    { name: 'Prior Authorizations', value: 'Prior Authorizations' },
    { name: 'Referrals', value: 'Referrals' }
];
export const TRANSACTION_TABLE_HEADER = [
    { name: 'Application', width: '222px' },
    { name: 'Transaction Type', width: '220px' },
    { name: 'Volume', width: '143px' },
    { name: 'Application %', width: '116px' },
];

export const nFormatter = (formatNumber, scValue?) => {
    if (typeof formatNumber !== 'number') return formatNumber;
    if (formatNumber >= 1000000000) return (formatNumber / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
    if (formatNumber >= 1000000) return (formatNumber / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (formatNumber >= 1000) return (formatNumber / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    if (formatNumber >= 0 && formatNumber < 1000 && scValue) return parseFloat(`${formatNumber}`).toFixed(0).replace(/\.0$/, '');
    if (formatNumber >= -999 && formatNumber < 0 && scValue) return parseFloat(`${formatNumber}`).toFixed(0).replace(/\.0$/, '');
    if (formatNumber >= -999999 && formatNumber < 0 && scValue) return (formatNumber / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    if (formatNumber <= -1000000 && formatNumber < 0 && scValue) return (formatNumber / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (formatNumber < 1000 && !scValue) return parseFloat(`${formatNumber}`).toFixed(1).replace(/\.0$/, '');
    return formatNumber;
}
export const nondecimalFormatter = (fnumber) => {
    if (typeof fnumber !== 'number') return fnumber;
    if (fnumber >= 1000000000) {
        return (fnumber / 1000000000).toFixed(0).replace(/\.0$/, '') + 'B';
    }
    if (fnumber >= 1000000) {
        return (fnumber / 1000000).toFixed(0).replace(/\.0$/, '') + 'M';
    }
    if (fnumber >= 1000) {
        return (fnumber / 1000).toFixed(0).replace(/\.0$/, '') + 'K';
    }
    if (fnumber < 1000) {
        return fnumber.toFixed(0).replace(/\.0$/, '');
    }
    if (fnumber < 0) {
        return fnumber.toFixed(0).replace(/\.0$/, '');
    }
    return fnumber;
}
export const formatDate = (Dates) => {
    const parts = Dates?.split('/');
    if(parts && parts !== undefined && parts.length > 0) {
        if (parts[0]?.length == 1) parts[0] = `0${parts[0]}`;
        if (parts[1]?.length == 1) parts[1] = `0${parts[1]}`;
        return `${parts[0]}/${parts[1]}/${parts[2]}`;
    }
}
export const formatDayValue = (value) => {
    if (!value || value === 'N/A') return 'N/A';
    if (value < 1) return '< 1 Day';
    else return `${nondecimalFormatter(value)} ${value <= 1 ? ' Day' : ' Days'}`;
};

export const getLastDateOfMonth = (dateString) => {
    const date = new Date(dateString);
    const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const formattedDate =
        (lastDate.getMonth() + 1).toString().padStart(2, '0') +
        '/' +
        lastDate.getDate().toString().padStart(2, '0') +
        '/' +
        lastDate.getFullYear();

    return formattedDate;
}

export const ErrorMetricCardFlags = {
    allMetricCard: false,
    savingMetricCard: false,
    solutionMetricCard: false,
    apiUtilizationMetricCard: false,
    transactionMetricCard: false
}

export const digitSolutionCards = {
    'allMetricCard': 'System Error.Because of system error, All Card has been suppressed',
    'savingMetricCard': 'Savings Opportunities With Digital Solutions',
    'solutionMetricCard': 'Digital Solutions Utilization',
    'apiUtilizationMetricCard': 'API Marketplace Utilization Details',
    'transactionMetricCard': 'Transaction Types'
}

export const legendDataDetails = [
    {
      label: 'Total',
      legendIndicator: 'dottedBar',
      legendColor: 'brown',
      legendvalue: 0,
      width: 'auto',
      roundedBar: true,
      checkBox: true,
      id: 0,
    },
    {
      label: 'Claims',
      legendIndicator: 'solidbar',
      legendColor: 'darkBlue',
      legendvalue: 0,
      width: 'auto',
      roundedBar: true,
      checkBox: false,
      id: 1,
    },
    {
      label: 'Prior Authorizations',
      legendIndicator: 'solidbar',
      legendColor: 'megenta',
      legendvalue: 0,
      width: 'auto',
      roundedBar: true,
      checkBox: false,
      id: 2,
    },
    {
      label: 'Referrals',
      legendIndicator: 'solidbar',
      legendColor: 'lightBlue',
      legendvalue: 0,
      width: 'auto',
      roundedBar: true,
      checkBox: false,
      id: 3,
    },
    {
      label: 'Eligibility',
      legendIndicator: 'solidbar',
      legendColor: 'DarkSkyBlue',
      legendvalue: 0,
      width: 'auto',
      roundedBar: true,
      checkBox: false,
      id: 4,
    }
  ];